define('lq/design/editors/dropPersistence',[
    'underscore',
    'when',
    'lq',
    'lq/drop',
    'lq/dispatcher',
    'lq/util',
    'lq/design/responsiveDesign',
    'lq/style',
    'lq/design/editors/dropCache'
], function (_, when, lq, Drop, dispatcher, util, responsiveDesign, StyleDesigner, dropCache) {
	'use strict';

    // todo backwards compatibility with the old designer (this will be removed eventually)
	var dropsWithViewModelKey = [
        'AutoComplete',
        'Barcode',
        'BoolImageInput',
        'BoolInput',
        'BusinessProcessCanvas',
        'Calendar',
		'Chart',
        'Circle',
        'Clock',
        'ColorPicker',
        'DateInput',
        'DocumentView',
        'Dropdown',
        'DynamicIframe',
        'DynamicImage',
        'DynamicSlideshow',
        'DynamicText',
        'DynamicVideo',
        'ErrorHandling',
        'GoogleMap',
        'GooglePlaces',
        'ImageKpi',
        'Input',
        'List',
        'MagicWand',
        'Hotspot',
        'Milestones',
        'MultiSelect',
        'NumericInput',
        'PlanningGraph',
        'RadioButton',
		'RadioButtonGroup',
        'RadioButtonGroupV2',
        'RadioButtonList',
        'RequirementsGraph',
        'RichTextTemplateEditor',
        'SketchPad',
        'TextArea',
        'TimeInput',
        'TreeView',
        'TreeView_v2',
        'RichTextEditor',
        'DocumentZip',
        'Milestones',
        'Gauge',
        'DataGrid',
        'PlanningGraph',
        'ProgressBar',
        'PlanningGraph',
        'Slider',
        'BaiduMaps',
	    'SimpleSpreadsheet',
        'DynamicBarcode',
        'RuntimeQueryBuilder',
		'Rectangle',
		'DocumentPreviewer',
		'Dropdown_v2',
		'GanttChart',
		'NormalDistribution',
		'CQCommand',
		'ModalAction',
		'ContentRegion',
		'DocumentIntelligencePreviewer'
    ];

	var getRootDrop = function (drop) {
	    while (drop.parent) {
	        drop = drop.parent;
	    }
	    return drop;
	};

    // todo find a nicer way to get around this. Maybe renaming it to Action again?
	var getControllerOfDrop = function (drop) {
	    if (drop.data.type === 'Action')
	        return 'LicquidAction';
	    return drop.data.type;
	};

	var addCommonRequestData = function (drop, requestData, rootDrop, operation) {
	    rootDrop = rootDrop || getRootDrop(drop);

		requestData.parentId = requestData.parentId || (drop.parent ? drop.parent.data.id : null);
		requestData.rootId = requestData.rootId || rootDrop.data.id;
		requestData.id = requestData.id || drop.data.id;

        if (operation === '/UpdateMorph' && rootDrop.languageId) {
            requestData.currentLanguageId = rootDrop.languageId;
        }

        return requestData;
	};

    var getCommonRequestData = function (drop, rootDrop) { // rootDrop is optional
        return addCommonRequestData(drop, {}, rootDrop);
    };

    var queuedServerCalls = [];

    var sendQueuedServerCalls = function () {
        var call = queuedServerCalls[0];

        return call.action()
            .then(function(response) {
                call.resolve(response);
            })
            .catch(function(jqxhr) {
                call.reject(jqxhr);
            })
            .done(function() {
                queuedServerCalls.shift();

                if (queuedServerCalls.length > 0) sendQueuedServerCalls();
            });
    };

    var queueServerCall = function (action) {
        return when.promise(function (resolve, reject) {
            queuedServerCalls.push({
                action: action,
                resolve: resolve,
                reject: reject
            });

            if (queuedServerCalls.length === 1) sendQueuedServerCalls();
        });
    };

    var dispatchRequest = function (drop, operation, requestData, inBackground) {
	    var rootDrop = getRootDrop(drop);

	    requestData = requestData || {};

	    addCommonRequestData(drop, requestData, rootDrop, operation);

        return queueServerCall(function() {
            var action = getControllerOfDrop(rootDrop) + operation;
            return inBackground
                ? dispatcher.backgroundDispatch(action, requestData)
                : dispatcher.dispatch(action, requestData);
        });
    };

    var unlockDrop = function (dropOrDrops) {
        var drops = _.flatten([dropOrDrops]);
        var rootDrop = getRootDrop(drops[0]);
        var dropIds = _.map(drops, function(drop) {
            return drop.data.id;
        });
        return dispatchRequest(rootDrop, '/UnlockMorph', {
            morphIds:  dropIds
        });
    };

    var lockDrop = function (dropOrDrops) {
        var drops = _.flatten([dropOrDrops]);
        var rootDrop = getRootDrop(drops[0]);
        var dropIds = _.map(drops, function(drop) {
            return drop.data.id;
        });
		return dispatchRequest(rootDrop, '/LockMorph', {
            morphIds:  dropIds
        });
	};

	var saveSizeAndPosition = function (dropOrDrops) {
	    var drops = _.flatten([dropOrDrops]);
	    if (drops.length === 0) {
	        return;
	    }
	    var rootDrop = getRootDrop(drops[0]);
	    var currentLayoutInfo = responsiveDesign.getCurrentLayout();

	    var morphSizeAndPositions = _.map(drops,
            function (drop) {
                var sizeAndPositionData = getCommonRequestData(drop, rootDrop);
                drop.decorateDataWithSizeAndPosition(sizeAndPositionData);
                if (currentLayoutInfo)
                    responsiveDesign.addLayoutReference(sizeAndPositionData, currentLayoutInfo);
                return sizeAndPositionData;
            });

	    var result = queueServerCall(function() {
	        return dispatcher
				.backgroundDispatch(getControllerOfDrop(rootDrop) + '/UpdateDropSizePositions', morphSizeAndPositions)
	            .then(function() {
	                _.each(drops, function(drop) {
	                    drop.triggerDropSizePositionUpdated();
	                });

	                // updates the layout specific properties
	                _.each(drops, function (drop) {
	                    responsiveDesign.updateLocalDropLayout(drop.data, function (layoutData) {
	                        drop.decorateDataWithSizeAndPosition(layoutData);
	                    });
	                    if (drop.savedDataBeforeEdit) {
	                        responsiveDesign.updateLocalDropLayout(drop.savedDataBeforeEdit, function (layoutData) {
	                            drop.decorateDataWithSizeAndPosition(layoutData);
	                            drop.savedAnchorBeforeEdit = util.cloneData(drop.anchor);
	                        });
	                    }
	                });
	            });
	    });

	    return result;
	};

	Drop.prototype.persistenceOperationSuffix = 'Morph';
	Drop.prototype.getCreateOperation = function () { return '/Create' + this.persistenceOperationSuffix; };
	Drop.prototype.getUpdateOperation = function () { return '/Update' + this.persistenceOperationSuffix; };
	Drop.prototype.getDeleteOperation = function () { return '/Delete' + this.persistenceOperationSuffix; };

	var backupCurrentData = function (drop) {
	    drop.savedDataBeforeEdit = util.cloneData(drop.data);
	    drop.savedAnchorBeforeEdit = util.cloneData(drop.anchor);
	};

	var revertChanges = function (drop) {
	    if (drop.savedDataBeforeEdit) {
	        drop.data = drop.savedDataBeforeEdit;
	        drop.anchor = drop.savedAnchorBeforeEdit;
	        drop.applyPosition();
	        drop.triggerChangesReverted();
	    }
	};

	var setPropertiesRecursive = function (drop, result) {
	    for (var property in result) {
	        if (!result.hasOwnProperty(property))
	            continue;

	        if (property.toLowerCase() === 'morphids')
	            continue;

	        if (result[property] !== null && result[property] !== undefined) {
	            var targetProperty = property.charAt(0).toLowerCase() + property.slice(1);
	            drop.data[targetProperty] = result[property];
	        }
	    }

	    _.each(result.MorphIds || result.morphIds, function (childResult, index) {
	        var childDrop = drop.pool[index];
	        setPropertiesRecursive(childDrop, childResult);
	    });
	};

	var getDropData = function (drop, isSkipLayoutData) {
	    var dropData = { };

	    drop.decorateDataWithSizeAndPosition(dropData);
	    drop.decorateData(dropData);

	    var propertyEditors = drop.currentPropertyEditors;

        if (!propertyEditors) {
            propertyEditors = [];
        } else if (!$.isArray(drop.currentPropertyEditors)) {
            propertyEditors = _.chain(Object.keys(drop.currentPropertyEditors))
                .map(function(key) {
                    return propertyEditors[key];
                })
                .flatten()
                .value();
        }

		// normal style should initialize without having to open the properties panel first
		_.each(propertyEditors, function(editor) {editor.initNormalStyleIfNeeded && editor.initNormalStyleIfNeeded()});

	    _.forEach(propertyEditors, function (propertyEditor) {
			propertyEditor.decorateData(dropData);
	    });

		// late decorators: for potentially overriding property editor values
		drop.decorateData(dropData, true);

	    // todo svb add these as a data decorator in action-design
        if (drop.data.id)
            dropData.id = drop.data.id;

	    dropData.type = drop.data.type;
        dropData.parentId = (drop.parent && drop.parent.data.id) ? drop.parent.data.id : null;
		dropData.locked = drop.data.locked;

        // prepare the data for the server
		if (!isSkipLayoutData) {
			dropData.layouts = $.extend(true, [], drop.data.layouts || [])
			responsiveDesign.updateServerDropLayout(dropData, function (layoutData) {
				// if there are 1 or more layouts defined we have to update the values of the current layout with the values we currently have in the designer
				responsiveDesign.copyDropLayout(drop.type, dropData, layoutData);

				// next we have to reset the fallback values that are used when no data exists for a specific layout (e.g. after adding a new layout)
				// on the server these values are stored in the root of the object (in the designer/client the values of the current
				// layout are stored in the root of the object)
				if (Drop.rootDrop.defaultLayout) {
					var defaultLayoutData = responsiveDesign.getLayoutData(dropData, Drop.rootDrop.defaultLayout);

					// when creating a drop in a non-default layout there won't be any data yet for the default layout
					//  => the values from the current layout become fallback values
					if (defaultLayoutData)
						responsiveDesign.copyDropLayout(drop.type, defaultLayoutData, dropData);
				}

				if (!dropData.id)
					responsiveDesign.copyDataOfCurrentLayoutToAllMissingLayouts(drop.type, dropData, layoutData);
			});
		}

        // overwrite the layout data with a version that contains data for every layout (instead of only the current layout)
        if (!dropData.id && dropData.layouts)
            drop.data.layouts = dropData.layouts;

	    dropData.parentId = (drop.parent && drop.parent.data.id) ? drop.parent.data.id : null;

	    // todo backwards compatibility with the old designer (this will be removed eventually)
	    if (dropsWithViewModelKey.indexOf(dropData.type) !== -1)
	        dropData.viewModelKey = dropData.name;

	    return dropData;
	};

	var getDropDataRecursive = function (drop, isSkipLayoutData) {
	    var dropData = getDropData(drop, isSkipLayoutData);
	    dropData.morphs = dropData.morphs || _.map(drop.pool, function(d) { return getDropDataRecursive(d, isSkipLayoutData); });
	    return dropData;
	};

	var saveRecursive = function (drop) {
	    return save(drop, true);
	};

	var save = function (drop, isRecursive, inBackground, isSkipLayoutData) {
	    var dropData = isRecursive ? getDropDataRecursive(drop, isSkipLayoutData) : getDropData(drop, isSkipLayoutData);
	    dropData.sendToBack = false;

	    var persistenceOperation = drop.data.id ?
			drop.getUpdateOperation() :
			drop.getCreateOperation();

	    if (isRecursive) {
	        persistenceOperation = util.addOrSetQueryParameterInUrl(persistenceOperation, 'allowChildMorphs', '');
	    }

	    return dispatchRequest(drop, persistenceOperation, dropData, inBackground)
	        .then(function (result) {
	            afterSave(drop, result);
	        });
	};

	var afterSave = function (drop, result) {
	    if (!drop.data.id) {
	        setPropertiesRecursive(drop, result);
	        drop.triggerDropCreated(result);
	        drop.triggerDropSaved(result);
	        drop.bubbleEvent('ChildDropCreated', drop);
			if (typeof drop.postCreate === "function") drop.postCreate();
	    } else { // This means that we clicked away
			if (typeof drop.style !== 'string')
				StyleDesigner.reloadStyleSheetForAction(drop.rootDrop.data.id);

	        drop.triggerDropUpdated(result);
	        drop.triggerDropSaved(result);
	        drop.bubbleEvent('ChildDropUpdated', drop);

	        if (drop.data.name !== undefined
                && drop.savedDataBeforeEdit !== undefined
                && drop.data.name !== drop.savedDataBeforeEdit.name) {
					drop.triggerDropRenamed(drop);
					drop.bubbleEvent('DropRenamed', drop);
				}
	    }
	    backupCurrentData(drop);
	};

    var pasteTool = function (toolId, parent, insertPosition, extraProperties) {
	    var requestData = {
	        toolId: toolId,
			parentId: parent.data.id,
            insertPosition: insertPosition,
            extraProperties: extraProperties,
			addToView: lq.isInMockMode() ? parent.rootDrop.newDropView : undefined,
		};
		var result = dispatchRequest(parent, '/PasteTool', requestData);
	    return result; // caller should call done()
	};

	var createTool = function (toolName, drops, forCurrentUser) {
	    var tool = {
	        toolName: toolName,
            dropIds: _.map(drops, function(drop) {
                return drop.data.id;
            }),
			forCurrentUser: forCurrentUser,
			isInMockMode: lq.isInMockMode()
	    };

		var result = queueServerCall(function () {
			return dispatcher.dispatch('Toolbox/Add', tool)
		});
	    return result; // caller should call done()
	};

	var deleteTool = function (toolId) {
		var result = queueServerCall(function () {
			return dispatcher.dispatch('Toolbox/Delete', { id: toolId, isInMockMode: lq.isInMockMode() }); // caller should call done() on returned promise
		});
		return result;
	};

	var remove = function (drop) {
	    return dispatchRequest(drop, drop.getDeleteOperation())
	        .then(function (data) {
	            drop.recursivelyHandleDeletion(data);
	        });
	};

	var removeAll = function (drops) {
	    if (!_.any(drops))
	        return when.resolve();

	    var rootDrop = getRootDrop(drops[0]);

	    var requestData = _.map(drops, function (drop) {
	        return getCommonRequestData(drop, rootDrop);
	    });

		return dispatchRequest(drops[0], '/DeleteMorphs', requestData)
	        .then(function () {
	            _.each(drops, function (drop) {
	                drop.recursivelyHandleDeletion();
	            });
	        });
	};

	var applySendToBack = function (drop, oldZIndex) {
	    _.each(drop.parent.pool, function (siblingDrop) {
	        if (siblingDrop.data.zIndex < oldZIndex && siblingDrop !== drop) {
	            siblingDrop.data.zIndex++;
	            siblingDrop.$element.css('zIndex', siblingDrop.data.zIndex);
	        }
	    });

	    drop.data.zIndex = 1;

	    if (drop.savedDataBeforeEdit)
	        drop.savedDataBeforeEdit.zIndex = 1;

        drop.$element.css('zIndex', 1);

        drop.triggerDropZIndexUpdated();
        drop.bubbleEvent('ChildDropZIndexUpdated', drop);
	};

	var applySendToFront = function (drop, oldZIndex) {
	    _.each(drop.parent.pool, function (siblingDrop) {
	        if (siblingDrop.data.zIndex > oldZIndex && siblingDrop !== drop) {
	            siblingDrop.data.zIndex--;
	            siblingDrop.$element.css('zIndex', siblingDrop.data.zIndex);
	        }
	    });

	    drop.data.zIndex = drop.parent.pool.length;

	    if (drop.savedDataBeforeEdit)
	        drop.savedDataBeforeEdit.zIndex = drop.data.zIndex;

        drop.$element.css('zIndex', drop.data.zIndex);

        drop.triggerDropZIndexUpdated();
        drop.bubbleEvent('ChildDropZIndexUpdated', drop);
	};

	var sendToBack = function (drop) {
	    var oldZIndex = drop.data.zIndex;
	    var result = dispatchRequest(drop, '/SendToBack')
	        .then(function () {
	            applySendToBack(drop, oldZIndex);
	        });
	    return result;
	};

	var sendToFront = function (drop) {
	    var oldZIndex = drop.data.zIndex;
	    var result = dispatchRequest(drop, '/SendToFront')
	        .then(function () {
	            applySendToFront(drop, oldZIndex);
	        });
	    return result;
	};

	var setZIndex = function (drop, zIndex) {
		return dispatchRequest(drop, '/SetZIndex', {
            zIndex: zIndex
	        })
			.then(function () {
				var dropsByZIndex = _.chain(drop.parent.pool)
					.filter(function (siblingDrop) { return siblingDrop !== drop; })
					.sortBy(function (siblingDrop) { return siblingDrop.data.zIndex; })
					.value();

				var insertIndex = dropsByZIndex.findIndex(function (drop) {
					return drop.data.zIndex >= zIndex;
				});
				if (insertIndex === -1)
					dropsByZIndex.push(drop);
				else
					dropsByZIndex.splice(insertIndex, 0, drop);

				_.each(dropsByZIndex, function (siblingDrop, index) {
					siblingDrop.data.zIndex = index + 1;
					siblingDrop.$element.css('zIndex', index + 1);
				});

				if (drop.savedDataBeforeEdit)
					drop.savedDataBeforeEdit.zIndex = zIndex;

                drop.triggerDropZIndexUpdated();
                drop.bubbleEvent('ChildDropZIndexUpdated', drop);
	        });
	};

	var embed = function (drop, newParent) {

	    var requestData = {
	        parentId: newParent.data.id,
	        morphIds: [drop.data.id]
	    };
	    // caller should call .done()
		return dispatchRequest(drop, '/EmbedMorphs', requestData);
	};

	var detach = function (drop) {

	    var requestData = {
	        morphIds: [drop.data.id]
	    };

		return dispatchRequest(drop, '/DetachMorphs', requestData);
	};

	var moveGridLayoutDimension = function (drop, oldPosition, newPosition, dimension, dimensionSize) {

	    var requestData = {
	        oldPosition: oldPosition,
	        newPosition: newPosition,
	        dimension: dimension,
            dimensionSize: dimensionSize
	    };

		return dispatchRequest(drop, '/MoveGridLayoutDimension', requestData);
	};

	var deleteGridLayoutDimension = function (drop, dimensionIndexToRemove, dimension, dimensionSize) {

	    var requestData = {
	        positionToRemove: dimensionIndexToRemove,
	        dimension: dimension,
	        dimensionSize: dimensionSize
	    };

		return dispatchRequest(drop, '/DeleteGridLayoutDimension', requestData);
    };

	var getDesignData = function (drop) {
		return dispatchRequest(drop, '/GetDesignData', {
                morphId: drop.data.id
            })
            .then(function (response) {
                return response.designData ? JSON.parse(response.designData) : null
            });
    };

	var getDesignDataBatched = function (ids) {
		return dispatcher.dispatch('LicquidAction/GetDesignDataBatched', {
                morphIds: ids
            })
            .then(function (response) {
				_.each(response.designData, function (value, key) {
					var drop = dropCache.getDropById(key);
					_.extend(drop.designData, JSON.parse(value));
				});
            });
    };

	return {
		save: save,
	    saveRecursive: saveRecursive,
	    unlockDrop: unlockDrop,
		lockDrop: lockDrop,
        saveSizeAndPosition: saveSizeAndPosition,
        sendToBack: sendToBack,
        sendToFront: sendToFront,
        createTool: createTool,
        deleteTool: deleteTool,
	    pasteTool: pasteTool,
        getDropData: getDropData,
        backupCurrentData: backupCurrentData,
        revertChanges: revertChanges,
        embed: embed,
        detach: detach,
        removeAll: removeAll,
        remove: remove,
        moveGridLayoutDimension: moveGridLayoutDimension,
        deleteGridLayoutDimension: deleteGridLayoutDimension,
        setZIndex: setZIndex,
		getDesignData: getDesignData,
		getDesignDataBatched: getDesignDataBatched,
        dispatchRequest: dispatchRequest,
        afterSave: afterSave
    };
});
